import { FC, useState } from 'react';

import { Form, Select } from 'antd';
import { Input, Label } from 'ui';
import { formRules } from 'utils/formRules';

import s from './EventOfferPerShow.module.scss';

const EventOfferFixedDiscount: FC = () => {
  const [discountType, setDiscountType] = useState<string>('%');
  return (
    <div className={s.wrapper}>
      <div className={s.row}>
        <div className={s.item}>
          <Label>
            Maximum tickets that can be sold with this offer (leave blank for unlimited tickets)
          </Label>
          <Form.Item name="numberOfTicketsAvailable" label="">
            <Input.Number
              style={{ width: '100%' }}
              name="numberOfTicketsAvailable"
              size="middle"></Input.Number>
          </Form.Item>
        </div>
      </div>
      <div className={s.row}>
        <div className={s.item}>
          <Label required>Discount</Label>
          <Form.Item rules={[formRules.required]} name="fixedDiscount" label="">
            <Input name="fixedDiscount" size="middle"></Input>
          </Form.Item>
        </div>
        <div className={s.item}>
          <Label>Type</Label>
          <Form.Item name="fixedDiscountValueType">
            <Select
              style={{ width: '100%', height: 40 }}
              onChange={(value) => setDiscountType(value)}
              options={[
                { value: 'percentage', label: '%' },
                { value: 'fixedValue', label: '€' },
              ]}
              value={discountType}
              defaultValue="percentage"
            />
          </Form.Item>
        </div>
      </div>
    </div>
  );
};

export default EventOfferFixedDiscount;
